import LeadRequirement from "./leadRequirement";
export default LeadRequirement;